import React, { useState } from 'react'
import { Button, Modal } from '@enamelai/design-system'
import { Icon as DeleteIcon } from '@enamelai/design-system/icons/Delete2'

type DeleteViewButtonProps = {
  handleDeleteView: (viewId: string) => Promise<void>
  selectedViewId: string
  selectedViewName: string
}

const DeleteViewButton = ({
  handleDeleteView,
  selectedViewId,
  selectedViewName,
}: DeleteViewButtonProps): React.ReactElement => {
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] =
    useState<boolean>(false)
  return (
    <>
      <Button
        variant="secondary"
        size="md"
        destructive
        className="reports-view-action-button"
        leftIcon={
          <DeleteIcon className="reports-view-action-icon" aria-hidden />
        }
        aria-label="Delete this view"
        title="Delete this view"
        onClick={() => setShowConfirmDeleteModal(true)}
      />
      <Modal
        open={showConfirmDeleteModal}
        onClose={() => setShowConfirmDeleteModal(false)}
        variant="confirmation"
        iconTone="danger"
        title="Confirm deletion"
        description={`Are you sure you want to delete the view named ${selectedViewName}?`}
        primaryLabel="Delete"
        primaryDestructive
        secondaryLabel="Cancel"
        onPrimaryClick={() => {
          void handleDeleteView(selectedViewId)
          setShowConfirmDeleteModal(false)
        }}
        onSecondaryClick={() => setShowConfirmDeleteModal(false)}
      />
    </>
  )
}

export default DeleteViewButton
